import { isComponentType } from '@backstage/plugin-catalog';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const componentApiDocsEntityContent = EntityContentBlueprint.make({
  name: 'driveline-component-api',
  params: {
    path: '/api',
    title: 'API',
    filter: isComponentType('service'),
    loader: () =>
      import('./ApiDocsEntityContent').then(module => (
        <module.ApiDocsEntityContent />
      )),
  },
});

const apiDefinitionEntityContent = EntityContentBlueprint.make({
  name: 'driveline-api-definition',
  params: {
    path: '/definition',
    title: 'Definition',
    filter: { kind: 'api' },
    loader: () =>
      import('./ApiDefinitionEntityContent').then(module => (
        <module.ApiDefinitionEntityContent />
      )),
  },
});

export const apiDocsEntityContentModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [componentApiDocsEntityContent, apiDefinitionEntityContent],
});
